//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    color: {
      type: String,
      default: "primary"
    },
    icon: {
      type: String,
      default: "mdi-check-bold"
    },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    path: {
      type: String,
      default: ""
    },
    list_path: {
      type: Array,
      default: null
    },
    agreement: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    liveRole: function liveRole() {
      return ['error', 'warning'].includes(this.color) ? 'alert' : 'status';
    }
  },
  created: function created() {},
  methods: {
    onClose: function onClose() {
      this.$store.commit("app/setShowMessage", false);
      this.$store.commit("app/setToastMessage", {});
      this.$emit("onClose");
    },
    onContinuar: function onContinuar() {
      var _redirect = this.path + "";
      this.onClose();
      console.log(_redirect);
      if (_redirect) {
        this.$router.push({
          name: _redirect
        });
      }
    },
    onVerItem: function onVerItem(item) {
      //this.$router.go({ path: item.path })
      var routeData = this.$router.resolve({
        name: item.path,
        query: {
          default: item.default_query
        }
      });
      window.open(routeData.href, '_blank');
    }
  }
};